import {ResourceService} from '@/internal';

export default class UserService extends ResourceService {
  constructor() {
    super();
    this.baseUrl = 'user';
  }
}
